<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// 获取当前客户端版本信息
const VERSION = process.env.VUE_APP_SENTRY_RELEASE_VERSION || 'local'
import { getVersion } from './api/common.js'
export default {
  name: 'App',
  mounted() {
    // 版本更新检查
    if (VERSION !== 'local') {
      const checkVersionInterval = setInterval(() => {
        console.log('checking version. local version:', VERSION)
        getVersion()
          .then((res) => {
            console.log('version:', res.data)
            if (res.data && res.data !== VERSION) {
              this.$message({
                message:
                  '版本有更新，请 <a href="javascript:location.reload()" style="color:#4a88f7">点击刷新体验</a>',
                duration: 0,
                dangerouslyUseHTMLString: true
              })
              clearInterval(checkVersionInterval)
            }
          })
          .catch((err) => {
            console.log('get version error:', err)
          })
      }, 1000 * 60)
    }
  }
}
</script>
